{
  "el": {
    "pagination": {
      "next": "Επόμενη σελίδα",
      "page_report": "Σελίδα {page} από {total}",
      "previous": "Προηγούμενη σελίδα",
      "report": "Εμφάνιση {first} έως {last} από {total}",
      "total": "Σύνολο στοιχείων: {total}"
    }
  }
}
